const Building = () => {
  return (
    <div className="flex justify-center items-center">
      <p>Página em construção</p>
    </div>
  );
};

export default Building;
